// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"68bb7c5e","845":"028f6a80"}[chunkId] + ".chunk.js";
};